import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
  summary: {
    gap: theme.spacing(1),
    flexDirection: "row-reverse",
    backgroundColor: theme.palette.programingOnDemandGrouped.module.backgroundColor,
    color: theme.palette.programingOnDemandGrouped.module.color,
    padding: theme.spacing(2),
  },
  details: {
    gap: theme.spacing(1),
    marginTop: theme.spacing(1), 
    marginBottom: theme.spacing(2), 
    flexDirection: "column",
    padding: 0,
    backgroundColor: "transparent !important",
    color: theme.palette.programingOnDemandGrouped.module.color,
  },
  titleContainer: {
    width: "100%"
  }
})); 